/**
 * Create a shipping label via Shippo API (calls your Netlify function).
 * @param {string} orderId
 * @param {object} customerInfo - Can be customer info or validated Shippo address
 * @param {Array} cartItems
 * @returns {Promise<object|null>}
 */
export async function createShippoLabel(orderId, customerInfo, cartItems) {
  // Static sender address
  const address_from = {
    name: "Kickin w' Crews",
    street1: "1441 E. Broad St.",
    street2: "Ste 342",
    city: "Fuquay-Varina",
    state: "NC",
    zip: "27526",
    country: "US",
  };

  // Customer shipping address - use validated Shippo address if it has objectId
  // Otherwise build from customerInfo format
  const address_to = customerInfo.objectId
    ? {
        name:
          customerInfo.name ||
          `${customerInfo.firstName || ""} ${customerInfo.lastName || ""}`.trim(),
        // Fallback to shipping* keys if validated fields are missing
        street1: customerInfo.street1 || customerInfo.shippingStreet,
        street2: customerInfo.street2 || customerInfo.shippingLine2 || "",
        city: customerInfo.city || customerInfo.shippingCity,
        state: customerInfo.state || customerInfo.shippingState,
        zip: customerInfo.zip || customerInfo.shippingPostal,
        country: customerInfo.country || customerInfo.shippingCountry || "US",
      }
    : {
        name: `${customerInfo.firstName} ${customerInfo.lastName}`.trim(),
        street1: customerInfo.shippingStreet,
        street2: customerInfo.shippingLine2 || "",
        city: customerInfo.shippingCity,
        state: customerInfo.shippingState,
        zip: customerInfo.shippingPostal,
        country: customerInfo.shippingCountry || "US",
      };

  // Static parcel dimensions (customize if needed)
  const parcels = cartItems.map((item) => ({
    length: 10,
    width: 5,
    height: 5,
    distance_unit: "in",
    weight: 6,
    mass_unit: "lb",
  }));

  try {
    const res = await fetch("/.netlify/functions/create-shippo-label", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        orderId,
        shipment: {
          address_from,
          address_to,
          parcels,
        },
      }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || "Failed to create Shippo label");
    return data;
  } catch (err) {
    console.error("Shippo label creation failed:", err);
    return null;
  }
}